// 
// -----------------------------------------------------------------------------
(function ($cookie) {
	if ($cookie.length === 0) {return false;}

	var accept = Cookies.get('accept');

	if ( accept === 'true') {
		Cookies.set('accept', true, { expires: 30 });
	}	else{
		$cookie.slideToggle();
	}

	function cookieFade(){
		$cookie.slideToggle();
	}

	$cookie.find('.close-cookie').on('click', cookieFade);

	$('.accept-cookie').on('click', function(){

		Cookies.set('accept', true, { expires: 30 });
		cookieFade();

	});


})($( '.cookie-pop' ));




